import { useVariant } from '@unleash/proxy-client-react'
import { useSelector } from 'react-redux'
import {
  getCategoryId,
  notFilterAndSortingApplied
} from 'src/redux-api-bridge/filters/selectors'
import { useMobileDevice } from './useMobileDevice'
import { MENU_CATEGORIES } from 'src/constants/menu'
import { getProfilesInfo } from 'src/redux-api-bridge/account/selectors'
import { getStoreId } from 'src/redux-api-bridge/selectors'
import { useEffect, useState } from 'react'
import { FF_GIFS_IN_MEAL_CARDS } from 'src/constants/feature-flags'

export const useGifsExperiment = () => {
  const [enabled, setEnabled] = useState(false)
  const [variant, setVariant] = useState()

  const categoryId = useSelector(getCategoryId)
  const noFiltersAndSorting = useSelector(notFilterAndSortingApplied)
  const isMobile = useMobileDevice()
  const profiles = useSelector(getProfilesInfo)
  const storeId = useSelector(getStoreId)

  const ff_variant = useVariant(FF_GIFS_IN_MEAL_CARDS.name)

  useEffect(() => {
    const profileWithoutRestrictions =
      profiles?.[0].diets.length === 0 &&
      !profiles?.[0].restrictions.some(
        r => r.id.startsWith('a') || r.id.startsWith('c')
      )
    const checkGifsExperiment =
      isMobile && storeId === 1 && profileWithoutRestrictions

    if (checkGifsExperiment) {
      setEnabled(ff_variant.enabled)
      setVariant(ff_variant.name)
    }
  }, [isMobile, profiles, storeId, ff_variant])

  return {
    gifsExperimentEnabled: enabled,
    gifsExperimentVariant: variant,
    displayGifs:
      enabled &&
      variant === FF_GIFS_IN_MEAL_CARDS.variantsMap.treatment1 &&
      categoryId === MENU_CATEGORIES.MEALS &&
      noFiltersAndSorting
  }
}
